import QUERY from 'lodash'

export default {
  data () {
    return {
      // Navigation State
      navigation: {
        mobileMenuOpen: false,
        activeDropdown: null,
        isScrolled: false
      },

      // Modal States
      modals: {
        lostItem: false,
        counseling: false,
        jobPlacement: false,
        medicalAppointment: false,
        appointment: false,
        contact: false
      },

      // Form States
      fetching: {
        contact: false,
        lostItem: false,
        counseling: false,
        jobPlacement: false,
        medical: false,
        appointment: false
      },

      // FAQ State
      activeFaq: null,

      // Back to Top
      showBackToTop: false
    }
  },

  methods: {
    // Navigation Methods
    toggleMobileMenu () {
      this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen
    },

    toggleDropdown (name) {
      this.navigation.activeDropdown = this.navigation.activeDropdown === name ? null : name
    },

    closeDropdowns () {
      this.navigation.activeDropdown = null
    },

    handleNavScroll () {
      this.navigation.isScrolled = window.scrollY > 50
      this.showBackToTop = window.scrollY > 300
    },

    scrollToSection (sectionId) {
      this.navigation.mobileMenuOpen = false
      this.navigation.activeDropdown = null
      const element = document.getElementById(sectionId)
      if (element) {
        const offset = 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - offset
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },

    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    // Modal Methods
    openModal (modalName) {
      this.modals[modalName] = true
      document.body.style.overflow = 'hidden'
    },

    closeModal (modalName) {
      this.modals[modalName] = false
      document.body.style.overflow = ''
    },

    closeAllModals () {
      Object.keys(this.modals).forEach(key => {
        this.modals[key] = false
      })
      document.body.style.overflow = ''
    },

    // FAQ Methods
    toggleFaq (index) {
      this.activeFaq = this.activeFaq === index ? null : index
    },

    // Debounced Search (for future use)
    searchDebounce: QUERY.debounce(function (callback) {
      callback()
    }, 500)
  },

  mounted () {
    window.addEventListener('scroll', this.handleNavScroll)
    document.addEventListener('click', event => {
      if (!event.target.closest('.dropdown-container')) {
        this.closeDropdowns()
      }
    })
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.closeAllModals()
      }
    })
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleNavScroll)
  }
}
